var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fill: "var(--color--primary-text)"
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "weather-cloud-wind-3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.809,13.5A.248.248,0,0,0,2,13.412a.245.245,0,0,0,.057-.2A4.5,4.5,0,0,1,6.581,8h0a1,1,0,0,0,.986-.834,5,5,0,0,1,9.647-.831,1,1,0,0,0,.9.667,2.5,2.5,0,0,1,2.232,3.365,1,1,0,0,0,.366,1.169,3,3,0,0,1,.816,4.077.253.253,0,0,0-.039.158c.007.075.011.151.011.228s0,.153-.01.227a.249.249,0,0,0,.249.273H23c.054,0,.108,0,.162,0a.248.248,0,0,0,.236-.13,4.993,4.993,0,0,0-.885-5.932.252.252,0,0,1-.071-.218A4.6,4.6,0,0,0,22.5,9.5a4.491,4.491,0,0,0-3.517-4.393.248.248,0,0,1-.171-.136,7,7,0,0,0-12.988.916.251.251,0,0,1-.205.173A6.509,6.509,0,0,0,0,12.5a6.594,6.594,0,0,0,.058.872.253.253,0,0,0,.109.174.249.249,0,0,0,.2.035A2.481,2.481,0,0,1,1,13.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19,17a1,1,0,0,0,0-2H1a1,1,0,0,0,0,2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23,18H4a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19,21H1a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMist);
export default __webpack_public_path__ + "static/media/mist.38f9d27737aa677fdb2c3ec312442cc9.svg";
export { ForwardRef as ReactComponent };